<template>
<div class="modal is-large" :class="{ 'is-active': active }">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="custom-modal-box">
            <div class="notification is-danger notification-text-size">
                This Digital Ocean server has been deleted through Digital Ocean.
            </div>

            <div class="backup">
                <!-- <div class="backup-title">Backup info</div> -->
                <div class="columns is-multiline">
                <div class="column is-3">
                    <div class="backup-frequency">
                        <div class="icon">
                            <font-awesome-icon icon="history"/>
                        </div>
                        <div class="details">
                            <div class="detail-label">
                                Frequency
                            </div>
                            <div class="detail-value">
                                Every 3 hours
                            </div>
                        </diV>
                    </div>
                </div>
                <div class="column is-3">
                    <div class="backup-retention">
                        <div class="icon">
                            <font-awesome-icon icon="calendar-day"/>
                        </div>
                        <div class="details">
                            <div class="detail-label">
                                Daily backups retention
                            </div>
                            <div class="detail-value">
                                Last 30 days
                            </div>
                        </diV>
                    </div>
                </div>
                <div class="column is-3">
                    <div class="backup-retention">
                        <div class="icon">
                            <font-awesome-icon icon="calendar-week"/>
                        </div>
                        <div class="details">
                            <div class="detail-label">
                                Weekly backups retention
                            </div>
                            <div class="detail-value">
                                Last 4 weeks
                            </div>
                        </diV>
                    </div>
                </div>
                <div class="column is-3">
                    <div class="backup-retention">
                        <div class="icon">
                            <font-awesome-icon icon="calendar"/>
                        </div>
                        <div class="details">
                            <div class="detail-label">
                                Monthly backups retention
                            </div>
                            <div class="detail-value">
                                Last 12 months
                            </div>
                        </diV>
                    </div>
                </div>
                </div>
                <!-- <div>Frequency: every 3 hours<font-awesome-icon icon="trash-alt"/></div>
                <div>Next backup: 2 hours<font-awesome-icon icon="trash-alt"/></div> -->
            </div>

            <div class="snapshots">
                <span class="snapshots-title">Snapshots</span>
                <table class="custom-table">
                    <thead>
                        <th>Status</th>
                        <th>Started</th>
                        <th>Duration</th>
                        <th>Tags</th>
                        <th>Region</th>
                        <th>Size</th>
                        <th>Actions</th>
                    </thead>
                    <tbody>
                        <tr>
                            <th><span class="tag is-success">completed</span></th>
                            <th><span class="column-text">1 hour ago</span></th>
                            <th><span class="column-text">4 min</span></th>
                            <th><span class="tag is-light">daily</span></th>
                            <th><span class="column-text">Frankfurt</span></th>
                            <th><span class="column-text">4GB</span></th>
                            <th><span class="tag is-danger delete-snapshot-tag"><font-awesome-icon icon="trash-alt"/></span></th>
                        </tr>
                        <tr>
                            <th><span class="tag is-success">completed</span></th>
                            <th><span class="column-text">1 hour ago</span></th>
                            <th><span class="column-text">4 min</span></th>
                            <th>
                                <span class="tag is-light">daily</span>&nbsp;
                                <span class="tag is-light">weekly</span>&nbsp;
                                <span class="tag is-light">monthly</span>
                            </th>
                            <th><span class="column-text">Frankfurt</span></th>
                            <th><span class="column-text">4GB</span></th>
                            <th><span class="tag is-danger delete-snapshot-tag"><font-awesome-icon icon="trash-alt"/></span></th>
                        </tr>
                        <tr>
                            <th><span class="tag is-success">completed</span></th>
                            <th><span class="column-text">1 hour ago</span></th>
                            <th><span class="column-text">4 min</span></th>
                            <th><span class="tag is-light">daily</span></th>
                            <th><span class="column-text">Frankfurt</span></th>
                            <th><span class="column-text">4GB</span></th>
                            <th><span class="tag is-danger delete-snapshot-tag"><font-awesome-icon icon="trash-alt"/></span></th>
                        </tr>
                        <tr>
                            <th><span class="tag is-success">completed</span></th>
                            <th><span class="column-text">1 hour ago</span></th>
                            <th><span class="column-text">4 min</span></th>
                            <th><span class="tag is-light">daily</span></th>
                            <th><span class="column-text">Frankfurt</span></th>
                            <th><span class="column-text">4GB</span></th>
                            <th><span class="tag is-danger delete-snapshot-tag"><font-awesome-icon icon="trash-alt"/></span></th>
                        </tr>
                        <tr>
                            <th><span class="tag is-success">completed</span></th>
                            <th><span class="column-text">1 hour ago</span></th>
                            <th><span class="column-text">4 min</span></th>
                            <th><span class="tag is-light">daily</span></th>
                            <th><span class="column-text">Frankfurt</span></th>
                            <th><span class="column-text">4GB</span></th>
                            <th><span class="tag is-danger delete-snapshot-tag"><font-awesome-icon icon="trash-alt"/></span></th>
                        </tr>
                        <tr>
                            <th><span class="tag is-success">completed</span></th>
                            <th><span class="column-text">1 hour ago</span></th>
                            <th><span class="column-text">4 min</span></th>
                            <th><span class="tag is-light">daily</span></th>
                            <th><span class="column-text">Frankfurt</span></th>
                            <th><span class="column-text">4GB</span></th>
                            <th><span class="tag is-danger delete-snapshot-tag"><font-awesome-icon icon="trash-alt"/></span></th>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
    <button @click="close" class="modal-close is-large" aria-label="close"></button>
</div>
</template>

<script>
export default {
    data() {
        return {
            active: false,
        }
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        close() {
            this.active = false;
        },

        listenEvents() {
            var vm = this;
            Event.$on('showCloudletDetails', () => {
                vm.active = true;
            });
        },
    },
}
</script>
